import React from "react";
import {
  Text,
  Input,
  FormLabel,
  InputGroup,
  FormControl,
} from "@chakra-ui/react";

const CustomTextInput = ({
  label,
  name = "",
  placeholder,
  value,
  type,
  labelColor,
  labelSize,
  disabled = false,
  onChange,
  error,
}) => {
  return (
    <FormControl>
      <FormLabel
        color={labelColor ? labelColor : "#000000"}
        marginBottom={2}
        fontFamily={"PlusJakartaSansMedium"}
        fontSize={labelSize ? labelSize : 12}
        textTransform={"capitalize"}
      >
        {label}
      </FormLabel>
      <InputGroup>
        <Input
          name={name}
          value={value}
          onChange={onChange}
          type={type}
          placeholder={placeholder}
          bg={"transparent"}
          fontFamily={"PlusJakartaSansRegular"}
          borderRadius={"4px"}
          fontSize={"12px"}
          lineHeight={"20"}
          color={"#000000"}
          _placeholder={{ color: "#898989" }}
          isDisabled={disabled}
        />
      </InputGroup>
      {error ? (
        <Text
          color="#FF0000"
          fontSize="12px"
          fontFamily={"PlusJakartaSansRegular"}
          lineHeight={"20px"}
          mt={1}
        >
          {error}
        </Text>
      ) : null}
    </FormControl>
  );
};

export default CustomTextInput;
